import { Palette } from '@mui/material';

enum PillVariant {
	Gray,
	Red,
	Orange,
	Yellow,
	Lime,
	Green,
	Cyan,
	Blue,
	Violet,
	Fuchsia,
}

export const getPillLabelColor = (variant: PillVariant, palette: Palette): string => {
	switch (variant) {
		case PillVariant.Gray:
			return palette.utilityGray700.main;
		case PillVariant.Red:
			return palette.utilityRed700.main;
		case PillVariant.Orange:
			return palette.utilityOrange700.main;
		case PillVariant.Yellow:
			return palette.utilityYellow700.main;
		case PillVariant.Lime:
			return palette.utilityLime700.main;
		case PillVariant.Green:
			return palette.utilityGreen700.main;
		case PillVariant.Cyan:
			return palette.utilityCyan700.main;
		case PillVariant.Blue:
			return palette.utilityBlue700.main;
		case PillVariant.Violet:
			return palette.utilityViolet700.main;
		case PillVariant.Fuchsia:
			return palette.utilityFuchsia700.main;
	}
};

export const getPillBorderColor = (variant: PillVariant, palette: Palette): string => {
	switch (variant) {
		case PillVariant.Gray:
			return palette.utilityGray200.main;
		case PillVariant.Red:
			return palette.utilityRed200.main;
		case PillVariant.Orange:
			return palette.utilityOrange200.main;
		case PillVariant.Yellow:
			return palette.utilityYellow200.main;
		case PillVariant.Lime:
			return palette.utilityLime200.main;
		case PillVariant.Green:
			return palette.utilityGreen200.main;
		case PillVariant.Cyan:
			return palette.utilityCyan200.main;
		case PillVariant.Blue:
			return palette.utilityBlue200.main;
		case PillVariant.Violet:
			return palette.utilityViolet200.main;
		case PillVariant.Fuchsia:
			return palette.utilityFuchsia200.main;
	}
};

export const getPillBackgroundColor = (variant: PillVariant, palette: Palette): string => {
	switch (variant) {
		case PillVariant.Gray:
			return palette.utilityGray50.main;
		case PillVariant.Red:
			return palette.utilityRed50.main;
		case PillVariant.Orange:
			return palette.utilityOrange50.main;
		case PillVariant.Yellow:
			return palette.utilityYellow50.main;
		case PillVariant.Lime:
			return palette.utilityLime50.main;
		case PillVariant.Green:
			return palette.utilityGreen50.main;
		case PillVariant.Cyan:
			return palette.utilityCyan50.main;
		case PillVariant.Blue:
			return palette.utilityBlue50.main;
		case PillVariant.Violet:
			return palette.utilityViolet50.main;
		case PillVariant.Fuchsia:
			return palette.utilityFuchsia50.main;
	}
};

export default PillVariant;
